import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import HeroMatrix from '../components/HeroMatrix';
import ServiceCards from '../components/ServiceCards';
import TestimonialsSection from '../components/TestimonialsSection';
import ClientsSection from '../components/ClientsSection';
import SEO from '../components/SEO';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title={t('hero.title')}
        description={t('hero.tagline')}
      />
      <div className="space-y-12">
      {/* Hero Matrix Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <HeroMatrix />
      </motion.section>

      {/* About Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-gray-800 border border-gray-700 rounded-2xl p-8"
      >
        <header className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-4">
            {t('about.title')}
          </h2>
        </header>

        <div className="space-y-6">
          <p className="text-lg font-semibold text-primary-300 italic">
            {t('hero.tagline')}
          </p>

          <p className="text-gray-300 leading-relaxed">
            {t('about.description')}
          </p>

          <p className="text-gray-300 leading-relaxed">
            <strong className="text-white">
              {t('about.interests')}
            </strong>
          </p>

          <div className="text-center pt-6">
            <button 
              className="btn-primary inline-flex items-center gap-2"
              onClick={() => navigate(`/${i18n.language || 'en'}/portfolio`)}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m8 0H8m8 0v6a2 2 0 01-2 2H10a2 2 0 01-2-2V6m8 0H8" />
              </svg>
              {t('hero.seeWork')}
            </button>
          </div>
        </div>
      </motion.section>

      {/* Services Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <ServiceCards />
      </motion.section>

      {/* Testimonials Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        <TestimonialsSection />
      </motion.section>

      {/* Clients Section */}
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        data-section="clients"
      >
        <ClientsSection />
      </motion.section>
    </div>
    </>
  );
};

export default Home;